<template>
<div class="link-panel">
  MY LINKS
</div>
</template>

<script>
import {
  BContainer,
  BRow,
  BCol,
} from 'bootstrap-vue'

export default {
  name: 'LinkPanel',
  props: {},
  data() {
    return {};
  },
  components: {
    'b-container': BContainer,
    'b-row': BRow,
    'b-col': BCol,
  },
  created() {},
  watch: {},
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';
.link-panel  {

}
</style>
